"use strict";

class App {
    static Initialize() {
        this.CSRF = InitialCSRF;
        $(document).on('submit', '[data-ajax-form]', function (event) {
            const form = $(this);
            const btn = form.find('[type="submit"]');
            const formUrl = form.attr('action');
            if (formUrl != undefined) {
                UI.buttonStartLoading(btn);
                App.post(formUrl, form, function (response) {
                    UI.buttonStopLoading(btn);
                    UI.handleJsonResponse(response);
                });
            }
            else {
                console.log('Error: The form has no action attribute.');
            }
            event.preventDefault();
            return false;
        });
    }
    static updateCSRF(callback) {
        $.ajax({
            url: BaseURL + 'getCSRF',
            type: 'GET',
            success: function (csrf) {
                App.setCSRF(csrf);
                if (callback != undefined) {
                    callback();
                }
            }
        });
    }
    static setCSRF(csrf) {
        App.CSRF = csrf;
        $('input[name="' + csrf.token + '"]').val(csrf.hash);
    }
    static getFormData(data) {
        let formData = new FormData();
        if (data != null) {
            if ($(data).is('form')) {
                formData = new FormData($(data)[0]);
            }
            else if (data instanceof FormData) {
                formData = data;
            }
            else if (typeof data == 'object') {
                formData = new FormData();
                for (var key in data) {
                    if (data[key] && data[key].isArray) {
                        $(data[key]).each(function (i, d2) {
                            formData.append(key + '[]', d2);
                        });
                    }
                    else {
                        if (data[key])
                            formData.append(key, data[key]);
                    }
                }
            }
        }
        return formData;
    }
    static ajaxForm(formSelector, callback) {
        let form = $(formSelector);
        const btn = form.find('[type="submit"]');
        form.on('submit', function (event) {
            UI.buttonStartLoading(btn);
            const formUrl = form.attr('action');
            if (formUrl != undefined) {
                App.post(formUrl, form, function (response) {
                    UI.buttonStopLoading(btn);
                    if (response.response) {
                        if (typeof callback != 'undefined') {
                            callback(response);
                        }
                        else {
                            UI.handleJsonResponse(response);
                        }
                    }
                    else {
                        UI.handleJsonResponse(response);
                    }
                });
            }
            else {
                console.log('Error: The form has no action attribute.');
            }
            event.preventDefault();
            return false;
        });
    }
    /**
     * Simple method to make an ajax post request.
     */
    static post(url, data, callback, updateCSRF = true) {
        let formData = App.getFormData(data);
        if (App.CSRF) {
            if (!formData.has(App.CSRF['token']))
                formData.append(App.CSRF['token'], App.CSRF['hash']);
        }
        $.ajax({
            url: url,
            data: formData,
            processData: false,
            contentType: false,
            type: 'POST',
            success: function (resp) {
                if (typeof resp.csrf != 'undefined') {
                    App.setCSRF(resp.csrf);
                }
                if (typeof callback != 'undefined') {
                    callback(resp);
                }
            },
            statusCode: {
                401: function () {
                    /*UI.authenticateModal(function(resp) {
                        App.setCSRF(resp.csrf);
                        App.post(url, data, callback);
                    }, {
                        onCancel: function() {*/
                    window.location.href = SiteURL + 'login';
                    /*}
                });*/
                },
                403: function (xhr) {
                    if (updateCSRF) {
                        App.updateCSRF(function () {
                            App.post(url, data, callback, false);
                        });
                    }
                },
                404: function() {
                    UI.stopLoadingOverlay();
                    UI.error('Page not found');
                },
                500: function (xhr) {
                    UI.stopLoadingOverlay();
                    UI.error(xhr.responseJSON.message);
                },
            }
        });
    }
    /**
     * Simple method to make an ajax post request.
     */
    static postAsync(url, data, updateCSRF = true) {
        return new Promise((resolve, reject) => {
            let formData = App.getFormData(data);
            if (App.CSRF) {
                if (!formData.has(App.CSRF['token']))
                    formData.append(App.CSRF['token'], App.CSRF['hash']);
            }
            $.ajax({
                url: url,
                data: formData,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (resp) {
                    if (typeof resp.csrf != 'undefined') {
                        App.setCSRF(resp.csrf);
                    }
                    resolve(resp);
                },
                statusCode: {
                    401: function () {
                        /*UI.authenticateModal(function(resp) {
                            App.setCSRF(resp.csrf);
                            App.post(url, data, callback);
                        }, {
                            onCancel: function() {*/
                            window.location.href = SiteURL + 'login';
                            /*}
                        });*/
                    },
                    403: function (xhr) {
                        if (updateCSRF) {
                            App.updateCSRF(function () {
                                App.postAsync(url, data, false).then(resolve).catch(reject);
                            });
                        }
                    },
                    404: function() {
                        UI.stopLoadingOverlay();
                        UI.error('Page not found');
                        reject(new Error('Page not found'));
                    },
                    500: function (xhr) {
                        UI.stopLoadingOverlay();
                        UI.error(xhr.responseJSON.message);
                        reject(new Error(xhr.responseJSON.message));
                    },
                }
            });
        });
    }
    static downloadText(filename, text) {
        var element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    static appendClientFingerprint(forms) {
        const append = () => {
            const ClientJS = window.ClientJS;
            const client = new ClientJS();
            if (Array.isArray(forms)) {
                forms.forEach((form) => {
                    $(form).append('<input type="hidden" name="clientFingerprint" value="'+client.getFingerprint()+'" />');
                });
            } else {
                $(forms).append('<input type="hidden" name="clientFingerprint" value="'+client.getFingerprint()+'" />');
            }
        }
        if (typeof window.ClientJS == 'undefined') {
            App.cachedScript(BaseURL + 'assets/frontend/js/libs/client.base.min.js').then(async function() {
                append();
            });
        } else {
            append();
        }
    }
    static cachedScript(url, type) {
        return new Promise((resolve, reject) => {
            try {
                const scriptEle = document.createElement("script");
                scriptEle.async = true;
                if (type != undefined && type != null) {
                    scriptEle.type = type;
                }
                scriptEle.src = url;
    
                scriptEle.addEventListener("load", (ev) => {
                    resolve({ status: true });
                });
    
                scriptEle.addEventListener("error", (ev) => {
                    reject({
                        status: false,
                        message: 'Failed to load the script ' + url
                    });
                });
    
                document.body.appendChild(scriptEle);
            } catch (error) {
                reject(error);
            }
        });
    }
    static cachedModule(url) {
        return App.cachedScript(url, 'module');
    }
    /**
     * Determine if an element is in the viewport
     * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Node}    elem The element
     * @return {Boolean} Returns true if element is in the viewport
     */
    static isInViewport(elem) {
        if (typeof elem == 'undefined')
            return false;
        if (typeof jQuery === "function" && elem instanceof jQuery) {
            elem = elem[0];
        }
        var distance = elem.getBoundingClientRect();
        return (distance.top >= 0 &&
            distance.left >= 0 &&
            distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            distance.right <= (window.innerWidth || document.documentElement.clientWidth));
    }
    /**
     * Determine if an element is in the viewport (Partially based on given percentage)
     * @param  {Node}    elem The element
     * @return {Boolean} Returns true if element is in the viewport
     */
    static isElementXPercentInViewport(elem, percentVisible) {
        if (typeof elem == 'undefined')
            return false;
        if (typeof jQuery === "function" && elem instanceof jQuery) {
            elem = elem[0];
        }
        let rect = elem.getBoundingClientRect(), windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        return !(
          Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100)) < percentVisible ||
          Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
        );
    }
}
(function () {
    App.Initialize();
})();